module.exports = __webpack_public_path__ + "static/media/zeeshan.8a7ee993.jpg";